/**
 * KPC-1 — pay-card registration before the onboarding hand-off.
 *
 * **The proxy ID never lands in this store.** It is entered, sent once and forgotten: it identifies a
 * financial instrument, the convention skill forbids bank details on the device, and a global store is
 * exactly the wrong place for a value whose lifetime is one request. Whatever the candidate types lives in
 * the component that collects it; only the OUTCOME below reaches the session.
 */
export const PAY_CARD_STATE = {
  /** Not asked yet. */
  pending: 'pending',
  /** The proxy id reached Bullhorn. */
  registered: 'registered',
  /**
   * A returning candidate said they do not need one.
   *
   * NOT a "skip" control. Decision 0089 makes the pay card a rule for everyone — "everybody takes a pay
   * card" — so this exists only for the returning candidate who already HAS one, which is the question
   * KPC-1 says to ask them. There is no direct-deposit opt-out anywhere in this feature.
   */
  notNeeded: 'notNeeded',
  /**
   * The barcode would not decode and the candidate could not key it either.
   *
   * Falls back to a recruiter keying it — a dead end at an unattended kiosk is a defect, so this state
   * routes to a person rather than to a retry loop.
   */
  handedToRecruiter: 'handedToRecruiter',
} as const;
export type PayCardState = (typeof PAY_CARD_STATE)[keyof typeof PAY_CARD_STATE];
